const app_id = 'pwy';

const env = process.env;
// console.log('Mode - Process ENV: ', env?.NODE_ENV, env);

const isProduction = () => {
    const prodMode = (env && env?.NODE_ENV === 'production');
    // console.log('Is Production Mode: ', prodMode);
    return prodMode;
}

const api_base = isProduction() ? 'https://theunoplatform.ai/api' : '/api';
const api_trigger = `${api_base}/trigger/send`;
const api_upload = `${api_base}/file/up`;

let session = localStorage.getItem('session',);
if (session) {
    session = JSON.parse(session);
}

const headers = {
    'Content-Type': 'application/json',
};

const sendTrigger = async (apiID, payload = {}, options = {}) => {
    const inputs = {
        method: 'POST',
        headers: headers,
        ...options,
        body: JSON.stringify({
            appID: app_id, input: {
                event: apiID,
                appID: app_id,
                session: session,
                ...payload
            }
        }),
    }

    return new Promise((resolve, reject) => {
        fetch(api_trigger, inputs)
            .then(async (response) => {
                resolve(await response.json());
            })
            .catch(async (error) => {
                console.log('Fetch ERROR: ', api_trigger, inputs, error);
                resolve({ error: error.message });
            });
    });
}

const upload = async (file) => {
    const formData = new FormData();
    formData.append('file', file, file.name);

    const inputs = {
        method: 'POST',
        headers: {
            'APP-ID': app_id,
            'MULTI-PART': true,
            'SESSION-ID': session?.id,
            'SERVER-ID': session?.serverID,
        },
        body: formData,
    }

    return new Promise((resolve, reject) => {
        fetch(api_upload, inputs)
            .then(async (response) => {
                resolve(await response.json());
            })
            .catch(async (error) => {
                console.log('Fetch ERROR: ', api_upload, inputs, error);
                resolve({ error: error.message });
            });
    });

}

export const TUP = {
    sendTrigger: sendTrigger,
    upload: upload,

    getSession: () => {
        return session;
    },

    setSession: (sess) => {
        // console.log('Setting session: ', sess);
        localStorage.setItem('session', JSON.stringify(sess));
        session = sess;
    },
}